import styled from 'styled-components';

const LargeText = styled.div`
  font-size: 1.6rem;
  margin: 65px;
  weight: bold;
  text-align: center;
`;

export default LargeText;
